import { useAppTranslation } from "@hooks/useAppTranslation";

const UnexpectedErrorMessage = () => {
  const { t } = useAppTranslation();

  return <span>{t("errors.unexpected")}</span>;
};

export default UnexpectedErrorMessage;
